export const formatDateFromSelect = (date: Date): string => {
  return date.toISOString().split("T")[0];
};
